import { render } from "./FormPajakSeriGenerate.vue?vue&type=template&id=5833e23a"
import script from "./FormPajakSeriGenerate.vue?vue&type=script&lang=js"
export * from "./FormPajakSeriGenerate.vue?vue&type=script&lang=js"

import "./FormPajakSeriGenerate.vue?vue&type=style&index=0&id=5833e23a&lang=css"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__